'use client';

import { Text } from '@backyard-ui/core';

import { useProductStore } from '@/presenters/store/catalog/product';
import { useGlobalStore } from '@/presenters/store/global';
import { formatDate } from '@/utils/date/formatDate';

function Disclaimer() {
  const { disclaimer, isAvailableOnEcommerce, isExclusiveOnEcommerce } =
    useProductStore((store) => store.product);

  const region = useGlobalStore((state) => state.session?.region);
  const regionName = useGlobalStore((state) => state.session?.regionName);

  const getPriceDisclaimer = () => {
    const today = formatDate(new Date(), 'DD/MM/YYYY');

    if (isExclusiveOnEcommerce || region === 'outros') {
      return (
        <span data-testid="exclusive-disclaimer">
          Preço válido para o dia <b>{today}</b>, para compras realizadas
          exclusivamente pelo Site, Televendas ou Whatsapp (11 4007-1380). O
          valor do frete não está incluso. Fotos meramente ilustrativas.
        </span>
      );
    } else if (isAvailableOnEcommerce) {
      return (
        <span data-testid="available-disclaimer">
          Preço válido para o dia <b>{today}</b> na região <b>{regionName} </b>{' '}
          em compras realizadas pelo Site, Televendas ou Whatsapp (11
          4007-1380). Para compras em nossas Lojas, verifique disponibilidade de
          estoque. O valor do frete não está incluso. Fotos meramente
          ilustrativas.
        </span>
      );
    }

    return (
      <span data-testid="default-disclaimer">
        Preço válido para o dia <b>{today}</b> na região <b>{regionName}</b> e
        apenas para retirada do produto diretamente nas Lojas. O valor do frete
        não está incluso. Verifique disponibilidade de estoque em nossas Lojas.
        Fotos meramente ilustrativas.
      </span>
    );
  };

  const priceDisclaimer = getPriceDisclaimer();

  return (
    <Text color="gray-700" size="sm" asChild>
      <p>
        {priceDisclaimer}
        {disclaimer && (
          <>
            <b> Atenção! </b>
            {disclaimer}
          </>
        )}
      </p>
    </Text>
  );
}

export default Disclaimer;
